import BuildingType from "@/roc/building/BuildingType";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const TravelingYurt = {
  id: "139",
  name: "Traveling Yurt",
  width: 4,
  height: 3,
  type: BuildingType.EVENT,
  era: "stoneAge",
  icon: "Traveling_Yurt",
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Traveling_Yurt',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.CAVALRY_DAMAGE_MOD,
      EffectAmount.asPerLevel([
        1.75, 1.75, 2.00, 2.00, 2.25, 2.25, 2.50, 2.50, 2.75, 2.75,
        3.00, 3.00, 3.25, 3.25, 3.50, 3.50, 3.75, 3.75, 4.00, 4.00,
        4.25, 4.25, 4.50, 4.50, 4.75, 4.75, 5.00, 5.00, 5.25, 5.25,
        5.50, 5.50, 5.75, 5.75, 6.00, 6.00, 6.25, 6.25, 6.50, 6.50,
        6.75, 6.75, 7.00, 7.00, 7.25, 7.25, 7.50, 7.50, 7.75, 7.75,
        8.00, 8.00, 8.25, 8.25, 8.50, 8.50, 8.75, 8.75, 9.00, 9.00,
      ]),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asCallbackWithLevel(
        (level) => {
          if (level <= 5) {
            return 1;
          }
          if (level <= 11) {
            return 2;
          }
          if (level <= 17) {
            return 3;
          }
          if (level <= 23) {
            return 4;
          }
          if (level <= 29) {
            return 5;
          }
          if (level <= 35) {
            return 6;
          }
          if (level <= 41) {
            return 7;
          }
          if (level <= 47) {
            return 8;
          }
          if (level <= 53) {
            return 9;
          }
          if (level <= 59) {
            return 10;
          }
          return 11;
        }
      ).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          133,140,147,154,161,168,175,182,189,196,203,210,217,224,231,238,245,252,259,266,273,280,287,294,301,308,315,322,329,336,343,350,357,364,371,378,385,392,399,406,413,420,427,434,441,448,455,462,469,476,483,490,497,504,511,518,525,532,539,546
        ],
        bronzeAge: [
          141,150,159,168,177,186,195,204,213,222,231,240,249,258,267,276,285,294,303,312,321,330,339,348,357,366,375,384,393,402,411,420,429,438,447,456,465,474,483,492,501,510,519,528,537,546,555,564,573,582,591,600,609,618,627,636,645,654,663,672
        ],
        minoanEra: [
          149,160,171,182,193,204,215,226,237,248,259,270,281,292,303,314,325,336,347,358,369,380,391,402,413,424,435,446,457,468,479,490,501,512,523,534,545,556,567,578,589,600,611,622,633,644,655,666,677,688,699,710,721,732,743,754,765,776,787,798
        ],
        classicGreece: [
          157,170,183,196,209,222,235,248,261,274,287,300,313,326,339,352,365,378,391,404,417,430,443,456,469,482,495,508,521,534,547,560,573,586,599,612,625,638,651,664,677,690,703,716,729,742,755,768,781,794,807,820,833,846,859,872,885,898,911,924
        ],
        earlyRome: [
          165,180,195,210,225,240,255,270,285,300,315,330,345,360,375,390,405,420,435,450,465,480,495,510,525,540,555,570,585,600,615,630,645,660,675,690,705,720,735,750,765,780,795,810,825,840,855,870,885,900,915,930,945,960,975,990,1005,1020,1035,1050
        ],
        romanEmpire: [
          173,190,207,224,241,258,275,292,309,326,343,360,377,394,411,428,445,462,479,496,513,530,547,564,581,598,615,632,649,666,683,700,717,734,751,768,785,802,819,836,853,870,887,904,921,938,955,972,989,1006,1023,1040,1057,1074,1091,1108,1125,1142,1159,1176
        ],
        byzantineEra: [
          173,190,207,224,241,258,275,292,309,326,343,360,377,394,411,428,445,462,479,496,513,530,547,564,581,598,615,632,649,666,683,700,717,734,751,768,785,802,819,836,853,870,887,904,921,938,955,972,989,1006,1023,1040,1057,1074,1091,1108,1125,1142,1159,1176
        ],
        ageOfTheFranks: [
          173,190,207,224,241,258,275,292,309,326,343,360,377,394,411,428,445,462,479,496,513,530,547,564,581,598,615,632,649,666,683,700,717,734,751,768,785,802,819,836,853,870,887,904,921,938,955,972,989,1006,1023,1040,1057,1074,1091,1108,1125,1142,1159,1176
        ],
        feudalAge: [
          173,190,207,224,241,258,275,292,309,326,343,360,377,394,411,428,445,462,479,496,513,530,547,564,581,598,615,632,649,666,683,700,717,734,751,768,785,802,819,836,853,870,887,904,921,938,955,972,989,1006,1023,1040,1057,1074,1091,1108,1125,1142,1159,1176
        ],
        iberianEra: [
          173,190,207,224,241,258,275,292,309,326,343,360,377,394,411,428,445,462,479,496,513,530,547,564,581,598,615,632,649,666,683,700,717,734,751,768,785,802,819,836,853,870,887,904,921,938,955,972,989,1006,1023,1040,1057,1074,1091,1108,1125,1142,1159,1176
        ],
        kingdomOfSicily: [
          173,190,207,224,241,258,275,292,309,326,343,360,377,394,411,428,445,462,479,496,513,530,547,564,581,598,615,632,649,666,683,700,717,734,751,768,785,802,819,836,853,870,887,904,921,938,955,972,989,1006,1023,1040,1057,1074,1091,1108,1125,1142,1159,1176
        ],
        highMiddleAges: [
          173,190,207,224,241,258,275,292,309,326,343,360,377,394,411,428,445,462,479,496,513,530,547,564,581,598,615,632,649,666,683,700,717,734,751,768,785,802,819,836,853,870,887,904,921,938,955,972,989,1006,1023,1040,1057,1074,1091,1108,1125,1142,1159,1176
        ],
        earlyGothicEra: [
          173,190,207,224,241,258,275,292,309,326,343,360,377,394,411,428,445,462,479,496,513,530,547,564,581,598,615,632,649,666,683,700,717,734,751,768,785,802,819,836,853,870,887,904,921,938,955,972,989,1006,1023,1040,1057,1074,1091,1108,1125,1142,1159,1176
        ],
        lateGothicEra: [
          173,190,207,224,241,258,275,292,309,326,343,360,377,394,411,428,445,462,479,496,513,530,547,564,581,598,615,632,649,666,683,700,717,734,751,768,785,802,819,836,853,870,887,904,921,938,955,972,989,1006,1023,1040,1057,1074,1091,1108,1125,1142,1159,1176
        ],
      }).withOutput(ProductionOutputType.CURRENT_ERA_PRIMARY_GOODS),
    ),
  ]),
};

export default TravelingYurt;
